import React, { useEffect } from 'react';
import HeaderLapidar from '~/components/layout/HeaderLapidar';

export default function LapidarPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = process.env.REACT_APP_CHALLENGE_LAPIDAR
    script.type = 'module';
    document.body.appendChild(script);

    const link = document.createElement('link');

    link.href = process.env.REACT_APP_CHALLENGE_LAPIDAR_CSS;
    link.type = 'text/css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    return () => {
      document.body.removeChild(script);
      document.head.removeChild(link);
    };
    
  }, []);

  return (
    <>
      <HeaderLapidar />
      <div data-js="root" style={{ background: '#fff' }}></div>
    </>
  );
}
